/**
 * Application Configuration
 * Central configuration file for the entire application
 */

import { awsConfig } from './aws';

export interface AppConfig {
  api: {
    baseUrl: string;
    timeout: number;
  };
  aws: typeof awsConfig;
  app: {
    name: string;
    version: string;
    environment: string;
  };
  features: {
    debugPanel: boolean;
    mockData: boolean;
  };
  ui: {
    defaultVideoUrl: string;
  };
}

// Application configuration with environment variable overrides
export const appConfig: AppConfig = {
  api: {
    baseUrl: process.env.NEXT_PUBLIC_API_GATEWAY_URL || 'http://localhost:3001',
    timeout: parseInt(process.env.NEXT_PUBLIC_API_TIMEOUT || '10000'),
  },
  aws: awsConfig,
  app: {
    name: process.env.NEXT_PUBLIC_APP_NAME || 'WiderTalk Commentary',
    version: process.env.NEXT_PUBLIC_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV || 'development',
  },
  features: {
    debugPanel: process.env.NEXT_PUBLIC_ENABLE_DEBUG_PANEL === 'true' || 
               process.env.NODE_ENV === 'development',
    mockData: process.env.NEXT_PUBLIC_USE_MOCK_DATA === 'true' || 
              process.env.NODE_ENV === 'development',
  },
  ui: {
    defaultVideoUrl: process.env.NEXT_PUBLIC_VIDEO_URL || '',
  },
};

/**
 * Validate configuration on startup
 */
export const validateConfig = (): void => {
  const requiredEnvVars = [
    'NEXT_PUBLIC_API_GATEWAY_URL',
  ];

  const missingVars = requiredEnvVars.filter(
    (varName) => !process.env[varName]
  );

  if (missingVars.length > 0) {
    console.warn(
      `Missing environment variables: ${missingVars.join(', ')}. ` +
      'Using default values for development.'
    );
  }

  console.log('📦 Configuration loaded:', {
    environment: appConfig.app.environment,
    apiBaseUrl: appConfig.api.baseUrl,
    awsRegion: appConfig.aws.region,
    ivsChatRegion: appConfig.aws.ivs.chat.region,
    debugMode: appConfig.features.debugPanel,
    mockData: appConfig.features.mockData,
  });
};

// Export individual configs for convenience
export { awsConfig } from './aws';
export default appConfig;